/**
 * Timing & easing constants for the Connect Apps animation.
 *
 * Single source of truth for both the JS phase machine
 * (`useConnectAppsAnimation`) and the CSS transitions in `index.tsx`.
 * Tests import these to derive total run time without hardcoding magic numbers.
 */

/** Duration of the pill background fade in/out at each end of the animation. */
export const CONNECT_APPS_BG_DURATION = 200;

/** Duration of the label slide-in/slide-out and gap easing. */
export const CONNECT_APPS_SLIDE_DURATION = 350;

/** Time each icon is fully visible before the next one starts crossfading in. */
export const HOLD_DURATION = 180;

/** Duration of the icon-to-icon crossfade. */
export const FADE_DURATION = 200;

/** Time from one icon becoming active to the next becoming active. */
export const CONNECT_APPS_ICON_STEP = HOLD_DURATION + FADE_DURATION;

/** Easing curve for the label slide and pill gap (ease-in-out, slow start). */
export const EASE_PILL = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

/** Easing curve for the icon-to-icon crossfade (symmetric ease-in-out). */
export const EASE_ICON_CROSSFADE = 'cubic-bezier(0.45, 0, 0.55, 1)';
